// Import your prop type config files to be exported in object literal here (Ex. typesConfig)
import typesConfig from './typesConfig';

const types = {
    types: typesConfig
};

export default types;